import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { Map, AlertTriangle, HardHat, Leaf, FileWarning, DollarSign } from 'lucide-react';

export function ZonesKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Khu Vực',
      value: 24,
      suffix: 'Khu',
      icon: Map,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Quy mô',
      chartColor: 'bg-indigo-500',
      chartData: [20, 22, 22, 23, 23, 24, 24]
    },
    {
      title: 'Cần Bảo Trì',
      value: 8,
      suffix: 'Khu',
      icon: AlertTriangle,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'up',
      trendValue: 'Ưu tiên cao',
      chartColor: 'bg-amber-500',
      chartData: [5, 5, 6, 6, 7, 8, 8]
    },
    {
      title: 'Đang Thi Công',
      value: 12,
      suffix: 'Khu',
      icon: HardHat,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Giai đoạn 2',
      chartColor: 'bg-blue-500',
      chartData: [8, 9, 10, 10, 11, 11, 12]
    },
    {
      title: 'Tỷ Lệ Phủ Xanh',
      value: 65,
      suffix: '%',
      icon: Leaf,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Mục tiêu 80%',
      chartColor: 'bg-emerald-500',
      chartData: [50, 52, 55, 58, 60, 62, 65]
    },
    {
      title: 'Sự Cố Tồn Đọng',
      value: 15,
      suffix: 'Vụ',
      icon: FileWarning,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Đã xử lý 5',
      chartColor: 'bg-rose-500',
      chartData: [25, 22, 20, 18, 17, 16, 15]
    },
    {
      title: 'Chi Phí Vận Hành',
      value: 1.2,
      suffix: 'Tỷ',
      icon: DollarSign,
      color: 'text-slate-600',
      bg: 'bg-slate-100',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-slate-500',
      chartData: [0.8, 0.9, 0.95, 1.0, 1.1, 1.15, 1.2]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
